/* Page kit (pk-*) v3 behaviour. One file, no dependencies. */
(function () {
if (window.__pkInit) return; window.__pkInit = true;
var design = function () { return !!(window.Shopify && window.Shopify.designMode); };

function digits(num, places, th, dec) {
var p = num.toFixed(places).split('.');
p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
return p.join(dec);
}
var FX = (function () {
var L = window.pkLocal || {}, r = parseFloat(L.rate);
return L.currency && r > 0 ? { cur: L.currency, sym: L.symbol || L.currency + ' ', rate: r, note: L.note || '' } : null;
})();
// Local price keeps the USD price's ending: $29.99 -> CA$41.99, $59.98 -> CA$83.98 (rounded up); whole USD -> whole local.
function fxCents(cents) {
var v = cents * FX.rate / 100, e = Math.round(cents) % 100;
if (!cents) return 0;
if (!e) return Math.round(v) * 100;
var r = Math.floor(v) + e / 100; if (r < v - 1e-9) r += 1;
return Math.round(r * 100);
}
function fmtMoney(cents, format, whole) {
if (FX) { var lc = fxCents(cents); return FX.sym + (whole ? digits(Math.round(lc / 100), 0, ',', '.') : digits(lc / 100, 2, ',', '.')); }
format = format || '${{amount}}';
var n = whole ? Math.round(cents / 100) : cents / 100;
return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
if (k === 'amount_no_decimals') return digits(n, 0, ',', '.');
if (k === 'amount_with_comma_separator') return digits(n, 2, '.', ',');
if (k === 'amount_no_decimals_with_comma_separator') return digits(n, 0, '.', ',');
return digits(n, 2, ',', '.');
}).replace(whole ? /[.,]00(?=\D*$)/ : /$^/, '');
}
function fxText(root) {
if (!FX) return;
var re = /(^|[^A-Za-z$])\$(\d{1,3}(?:,\d{3})*(?:\.\d{2})?)/g;
root.querySelectorAll('.pk-hero, .pk-sticky, .pk-giftsec, .pk-banner, .pk-sec:not(.pk-revsec)').forEach(function (sec) {
var w = document.createTreeWalker(sec, NodeFilter.SHOW_TEXT), n, list = [];
while ((n = w.nextNode())) if (n.nodeValue.indexOf('$') > -1) list.push(n);
list.forEach(function (t) {
t.nodeValue = t.nodeValue.replace(re, function (_, pre, num) {
var cents = Math.round(parseFloat(num.replace(/,/g, '')) * 100);
return pre + fmtMoney(cents, null, num.indexOf('.') < 0);
});
});
});
}
window.pkMoney = fmtMoney;

function saveText(total, compare, fmt) {
if (!compare || compare <= total) return '';
var diff = compare - total;
if (compare < 10000) return 'Save ' + Math.round(diff / compare * 100) + '%';
return 'Save ' + fmtMoney(diff, fmt, true);
}

function fillDates(root) {
(root || document).querySelectorAll('[data-pk-dates], .pk-banner__item, .pk-giftsec h2').forEach(function (el) {
if (el.dataset.done) return; el.dataset.done = 1;
el.innerHTML = el.innerHTML.replace(/\{\+(\d+)\}/g, function (_, n) {
var dt = new Date(); var add = parseInt(n, 10);
while (add > 0) { dt.setDate(dt.getDate() + 1); if (dt.getDay() % 6) add--; }
return '<b>' + dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + '</b>';
}).replace(/\{d\+(\d+)\}/g, function (_, n) {
var dt = new Date(); dt.setDate(dt.getDate() + parseInt(n, 10));
return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
});
});
}

// Marquee speed in pixels per second, so it moves at the same pace whatever the number of items or screen width.
function initMarquee(el) {
var tr = el.querySelector('.pk-marquee__track'), pace = +el.dataset.pace || 40;
var set = function () { var w = tr.scrollWidth / 2; if (w > 0) el.style.setProperty('--pk-mq-s', Math.round(w / pace) + 's'); };
set(); window.addEventListener('resize', set);
if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
}
function initBanner(el) {
if (el.dataset.top === 'true' && !design()) {
var sec = el.closest('.shopify-section') || el;
document.body.insertBefore(sec, document.body.firstChild);
}
var items = el.querySelectorAll('.pk-banner__item');
if (items.length < 2) return;
var i = 0, ms = (parseFloat(el.dataset.speed) || 4) * 1000;
setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, ms);
}

function initGallery(g) {
var track = g.querySelector('.pk-gal__track'); if (!track) return;
var slides = track.children, thumbs = g.querySelectorAll('.pk-gal__thumbs button');
function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
var p = g.querySelector('.pk-gal__nav--prev'), n = g.querySelector('.pk-gal__nav--next');
p && p.addEventListener('click', function () { go(cur() - 1); });
n && n.addEventListener('click', function () { go(cur() + 1); });
var t; track.addEventListener('scroll', function () {
clearTimeout(t); t = setTimeout(function () {
var c = cur(); thumbs.forEach(function (b, i) { b.classList.toggle('is-on', i === c); });
var on = thumbs[c]; if (on && on.parentElement) { var tb = on.parentElement; tb.scrollTo({ left: on.offsetLeft - tb.clientWidth / 2 + on.clientWidth / 2, behavior: 'smooth' }); }
}, 60);
}, { passive: true });
}

function initCarousel(c) {
var track = c.querySelector('.pk-car__track'); if (!track) return;
var prev = c.querySelector('.pk-car__nav--prev'), next = c.querySelector('.pk-car__nav--next');
function step() { var f = track.children[0]; if (!f) return track.clientWidth; var g = parseFloat(getComputedStyle(track).columnGap) || 16; return f.getBoundingClientRect().width + g; }
function upd() {
var max = track.scrollWidth - track.clientWidth - 2;
if (prev) prev.disabled = track.scrollLeft <= 2;
if (next) next.disabled = track.scrollLeft >= max;
var img = track.querySelector('img'); if (img && img.clientHeight) c.style.setProperty('--pk-car-top', (img.clientHeight / 2) + 'px');
}
prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
window.addEventListener('resize', upd); window.addEventListener('load', upd); upd();
}

var boxes = [];
function initBuy(box) {
var cfgEl = box.querySelector('script[type="application/json"]'); if (!cfgEl) return;
var cfg = JSON.parse(cfgEl.textContent), fmt = cfg.moneyFormat;
var scope = box.closest('section') || box;
var tiers = box.querySelectorAll('.pk-tier');
var bump = box.querySelector('.pk-bump input');
var err = box.querySelector('.pk-err');
var priceNow = scope.querySelector('.pk-price__now'), priceWas = scope.querySelector('.pk-price__was'), priceBadge = scope.querySelector('.pk-price .pk-badge');
var api = { box: box, cfg: cfg, idx: 0, listeners: [] };

function calc(t) {
t = t || { qty: 1, pct: 0 };
var total = cfg.free ? 0 : Math.round(cfg.price * t.qty * (1 - (t.pct || 0) / 100));
var compare = (cfg.compare > cfg.price ? cfg.compare : cfg.price) * t.qty;
return { total: total, compare: compare };
}
api.calc = function (i) { return calc(cfg.tiers[i]); };
api.money = function (c) { return fmtMoney(c, fmt); };
function tier() { return cfg.tiers[api.idx] || { qty: 1, pct: 0, code: '' }; }
function total() { return calc(tier()).total + (bump && bump.checked ? cfg.bump.price : 0); }
api.total = total;

var shown = false;
function tick(el, txt) {
if (el.textContent === txt) return;
el.textContent = txt;
if (!shown) return;
el.classList.remove('pk-tick'); void el.offsetWidth; el.classList.add('pk-tick');
}
function render() {
var t = tier(), c = calc(t);
tiers.forEach(function (el, k) { var on = k === api.idx; el.classList.toggle('is-on', on); var r = el.querySelector('input'); if (r) r.checked = on; });
var gr = box.querySelector('.pk-gifts-row');
if (gr) gr.classList.toggle('is-locked', t.qty < (cfg.giftsMin || 1));
if (priceNow) tick(priceNow, fmtMoney(c.total, fmt));
if (priceWas) priceWas.textContent = c.compare > c.total ? fmtMoney(c.compare, fmt) : '';
if (priceBadge) { var s = cfg.free ? 'Free' : saveText(c.total, c.compare, fmt); priceBadge.textContent = s; priceBadge.hidden = !s; }
var lab = cfg.label + (cfg.showPrice ? ' · ' + fmtMoney(total(), fmt) : '');
box.querySelectorAll('.pk-buy [data-pk-label]').forEach(function (l) { tick(l, lab); });
api.listeners.forEach(function (fn) { fn(); });
shown = true;
}
api.render = render;
api.select = function (i) { api.idx = Math.max(0, Math.min(i, cfg.tiers.length - 1)); render(); };

tiers.forEach(function (el, k) {
cfg.tiers[k] = cfg.tiers[k] || { qty: 1, pct: 0, code: '' };
var c = calc(cfg.tiers[k]);
var now = el.querySelector('.pk-tier__now'), was = el.querySelector('.pk-tier__was');
if (now) now.textContent = fmtMoney(c.total, fmt);
if (was) was.textContent = c.compare > c.total ? fmtMoney(c.compare, fmt) : '';
var pill = el.querySelector('[data-pk-pill]');
if (pill) { var sv = c.compare - c.total; pill.textContent = pill.dataset.pkPill.replace('[save]', fmtMoney(sv, fmt, true)); pill.hidden = sv <= 0 && pill.dataset.pkPill.indexOf('[save]') > -1; }
if (el.classList.contains('is-on')) api.idx = k;
el.addEventListener('click', function (e) { if (e.target.closest('select')) return; api.select(k); });
});
if (bump) bump.addEventListener('change', function () { bump.closest('.pk-bump').classList.toggle('is-on', bump.checked); render(); });

function items() {
var t = tier(), out = {};
var on = box.querySelector('.pk-tier.is-on');
var sels = on ? on.querySelectorAll('select') : [];
if (sels.length) sels.forEach(function (s) { out[s.value] = (out[s.value] || 0) + 1; });
else out[cfg.variant] = t.qty;
var list = Object.keys(out).map(function (id) { return { id: +id, quantity: out[id] }; });
if (bump && bump.checked && cfg.bump.variant) list.push({ id: cfg.bump.variant, quantity: 1 });
if ((cfg.gifts || []).length && t.qty >= (cfg.giftsMin || 1)) cfg.gifts.forEach(function (g, i) {
var cb = box.querySelector('[data-pk-gift="' + i + '"]');
if (!cb || cb.checked) list.push({ id: +g, quantity: 1, properties: { _pk_gift: String(cfg.product), _pk_min: String(cfg.giftsMin || 1) } });
});
return list;
}
var busy = false;
api.buy = function (dest, btn) {
if (design() || busy) return;
busy = true; if (btn) btn.disabled = true; if (err) err.textContent = '';
var t = tier();
var clear = cfg.clearCart ? fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }) : Promise.resolve();
clear.then(function () {
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items() }) });
}).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
.then(function () {
var drawer = dest === 'drawer' && window.PKCart;
var to = dest === 'checkout' ? '/checkout' : '/cart';
return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: t.code || '' }) })
.then(function (r) { if (!r.ok) throw 0; if (drawer) { busy = false; if (btn) btn.disabled = false; window.PKCart.open(); return; } window.location.href = to; })
.catch(function () { window.location.href = t.code ? '/discount/' + encodeURIComponent(t.code) + '?redirect=' + encodeURIComponent(to) : to; });
})
.catch(function (ex) { busy = false; if (btn) btn.disabled = false; if (err) err.textContent = ex.message; });
};
box.querySelectorAll('[data-pk-go]').forEach(function (b) {
b.addEventListener('click', function (e) { e.preventDefault(); api.buy(b.dataset.pkGo, b); });
});
if (FX && FX.note && !box.querySelector('.pk-fx-note')) {
var fx = document.createElement('p'); fx.className = 'pk-fx-note'; fx.textContent = FX.note;
fx.style.cssText = 'margin:8px 0 0;font-size:12px;line-height:1.4;color:var(--pk-muted);text-align:center';
var anchor = box.querySelector('.pk-pay') || box.querySelector('.pk-delivery') || box.querySelector('.pk-err');
if (anchor) anchor.insertAdjacentElement('afterend', fx);
}
render();
box.__pk = api; boxes.push(api);
// the side cart keeps the bundle price and the gifts when the quantity changes there
try {
var rules = JSON.parse(localStorage.getItem('pk_cart_rules') || '{}');
rules[cfg.product] = { tiers: cfg.tiers.map(function (x) { return { qty: x.qty, code: x.code || '' }; }), gifts: cfg.gifts || [], giftsMin: cfg.giftsMin || 1 };
localStorage.setItem('pk_cart_rules', JSON.stringify(rules));
} catch (e) {}
return api;
}

function initSticky(st) {
var box = document.getElementById(st.dataset.for); if (!box || !box.__pk) return;
var api = box.__pk, btns = st.querySelectorAll('.pk-sticky__tier'), buy = st.querySelector('[data-pk-sticky-buy]');
btns.forEach(function (b, k) {
var c = api.calc(k);
b.querySelector('i').textContent = api.money(c.total);
b.querySelector('s').textContent = c.compare > c.total ? api.money(c.compare) : '';
b.addEventListener('click', function () { api.select(k); });
});
var sum = st.querySelector('[data-pk-sticky-sum]'), row = st.querySelector('.pk-sticky__row');
if (!sum && row) {
sum = document.createElement('button'); sum.type = 'button'; sum.className = 'pk-sticky__sum'; sum.tabIndex = -1;
sum.setAttribute('data-pk-sticky-sum', '');
sum.innerHTML = '<span><b></b><s></s></span><u>' + (st.dataset.change || 'Change bundle') + '</u>';
row.insertBefore(sum, row.firstChild);
}
sum && sum.addEventListener('click', function () { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
function sync() {
btns.forEach(function (b, k) { b.classList.toggle('is-on', k === api.idx); });
if (sum && btns[api.idx]) {
var c = api.calc(api.idx);
sum.querySelector('b').textContent = btns[api.idx].querySelector('b').textContent;
sum.querySelector('s').textContent = c.compare > c.total ? api.money(c.compare) : '';
}
var l = buy && buy.querySelector('[data-pk-label]');
if (l) l.textContent = api.cfg.label + (api.cfg.showPrice ? ' · ' + api.money(api.total()) : '');
}
api.listeners.push(sync); sync();
buy && buy.addEventListener('click', function () { api.buy(box.querySelector('.pk-buy').dataset.pkGo || 'cart', buy); });
var cta = box.querySelector('.pk-buy') || box;
var phone = window.matchMedia('(max-width: 749px)');
var visible = new Map();
function update() {
var any = false; visible.forEach(function (v) { if (v) any = true; });
var r = cta.getBoundingClientRect();
var past = r.bottom < 0;
var mini = !past && !!sum && st.dataset.mini !== 'false' && phone.matches && r.top > window.innerHeight;
var on = (past || mini) && !any;
st.classList.toggle('is-on', on); st.classList.toggle('is-mini', on && mini); st.setAttribute('aria-hidden', on ? 'false' : 'true');
st.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
document.body.style.paddingBottom = on ? st.offsetHeight + 'px' : '';
}
if ('IntersectionObserver' in window) {
var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { visible.set(en.target, en.isIntersecting); }); update(); });
document.querySelectorAll('.pk-buybox').forEach(function (b) { io.observe(b); });
}
window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
}

function initQuickLinks() {
document.addEventListener('click', function (e) {
var a = e.target.closest('[data-pk-buynow], a[href="#pk-buy"]'); if (!a) return;
var main = boxes.filter(function (b) { return b.cfg.main; })[0] || boxes[0]; if (!main) return;
e.preventDefault();
if (a.hasAttribute('data-pk-buynow')) main.buy(a.getAttribute('data-pk-buynow') || 'checkout', a);
else main.box.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
}

function initBA(el) {
var r = el.querySelector('input'); if (!r) return;
var set = function () { el.style.setProperty('--pk-ba', r.value + '%'); };
r.addEventListener('input', set); set();
}

function initReviews(el) {
var dlg = el.querySelector('dialog.pk-wr');
if (dlg && dlg.showModal) {
el.querySelectorAll('[data-pk-write]').forEach(function (b) { b.addEventListener('click', function () { dlg.showModal(); }); });
dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-pk-close]')) dlg.close(); });
if (dlg.querySelector('[data-pk-posted]')) dlg.showModal();
}
var more = el.querySelector('.pk-rev__more'); if (!more) return;
var step = parseInt(el.dataset.more || '12', 10);
more.addEventListener('click', function () {
var hidden = el.querySelectorAll('.pk-rev[hidden]');
for (var i = 0; i < Math.min(step, hidden.length); i++) hidden[i].hidden = false;
if (hidden.length <= step) more.hidden = true;
});
}

function initMotion(root) {
if (!document.documentElement.classList.contains('pk-anim') || design() || !window.IntersectionObserver) return;
var sel = '.pk-sec .pk-head, .pk-hero--compact .pk-head, .pk-hero--compact .pk-buybox, .pk-sec .pk-frame, .pk-points>li, .pk-split__cta, .pk-car, .pk-use, .pk-tl__list>*, .pk-table-wrap, .pk-giftlist, .pk-faqsec .pk-acc>*, .pk-rev__top, .pk-rev__list';
var todo = [];
function show(el) {
var k = todo.indexOf(el); if (k < 0) return; todo.splice(k, 1);
io.unobserve(el); el.classList.add('is-in');
var d = parseFloat(el.style.getPropertyValue('--pk-d')) || 0;
setTimeout(function () { el.removeAttribute('data-pk-rv'); el.classList.remove('is-in'); el.style.removeProperty('--pk-d'); }, 1500 + d * 1000);
}
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.bottom <= 0) show(e.target); });
}, { rootMargin: '0px 0px -8% 0px' });
var busy = false;
function sweep() {
busy = false;
todo.slice().forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 0.92) show(el); });
if (!todo.length) window.removeEventListener('scroll', onScroll);
}
function onScroll() { if (!busy) { busy = true; window.requestAnimationFrame(sweep); } }
root.querySelectorAll(sel).forEach(function (el) {
if (el.hasAttribute('data-pk-rv') || (el.parentElement && el.parentElement.closest('[data-pk-rv]'))) return;
var i = 0, s = el.previousElementSibling;
while (s) { if (s.hasAttribute('data-pk-rv')) i++; s = s.previousElementSibling; }
if (i) el.style.setProperty('--pk-d', Math.min(i, 5) * 0.08 + 's');
el.setAttribute('data-pk-rv', ''); todo.push(el); io.observe(el);
});
if (todo.length) window.addEventListener('scroll', onScroll, { passive: true });
}

function init(root) {
root = root || document;
fxText(root);
root.querySelectorAll('.pk-banner').forEach(initBanner);
root.querySelectorAll('.pk-marquee[data-pace]').forEach(initMarquee);
root.querySelectorAll('.pk-gal').forEach(initGallery);
root.querySelectorAll('.pk-car').forEach(initCarousel);
root.querySelectorAll('.pk-buybox').forEach(initBuy);
root.querySelectorAll('.pk-sticky').forEach(initSticky);
root.querySelectorAll('.pk-ba').forEach(initBA);
root.querySelectorAll('.pk-revsec').forEach(initReviews);
fillDates(root);
initMotion(root);
}
initQuickLinks();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
else init();
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
